import { render, staticRenderFns } from "./ShopSearch.vue?vue&type=template&id=4b79f436"
import script from "./ShopSearch.vue?vue&type=script&lang=js"
export * from "./ShopSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports